<template>
  <el-dialog
    width="500px"
    :visible.sync="dialogVisible"
    :lock-scroll="false"
    :show-close="false"
    class="qrcode-dialog-component"
  >
    <div class="qrcode-content">
      <img class="icon-title" :src="data.titleIcon" />
      <img class="icon-qrcode" :src="data.qrcode" />
      <img
        class="icon-close"
        src="./img/icon_dialog_close.png"
        @click="dialogVisible = false"
      />
      <div v-if="data.buttonText" class="button">
        <div class="btn">{{ data.buttonText }}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    value: Boolean,
    data: Object
  },
  computed: {
    dialogVisible: {
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('input', value);
      }
    }
  }
};
</script>

<style scoped>
.qrcode-dialog-component {
  /deep/ .el-dialog {
    margin-top: calc(50vh - 250px) !important;
    background: transparent;
    box-shadow: none;
  }
  /deep/ .el-dialog__header,
  /deep/ .el-dialog__body {
    padding: 0;
  }
}
.qrcode-content {
  position: relative;
  padding-top: 40px;
  width: 500px;
  text-align: center;
  height: 500px;
  background: #ffffff;
  border-radius: 20px;
  .icon-title {
    width: 350px;
    height: 70px;
  }
  .icon-qrcode {
    margin-top: 30px;
    width: 260px;
    height: 260px;
  }
  .icon-close {
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    width: 40px;
    height: 40px;
  }
  .button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 40px;
      height: 36px;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      color: #000000;
      background: #ffe100;
      border-radius: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/qrcode-dialog.vue